import * as types from "../actions/types";

const initialState = {
  servers: [],
  loading: false
};

export default function servers(state = initialState, action) {
  switch (action.type) {
    case types.SET_SERVERS_DATA:
      return {
        ...state,
        servers: action.payload
      };
    
    case types.ADD_SERVER:
      return {
        ...state,
        servers: [...state.servers, action.payload]
      };
    
    case types.UPDATE_SERVER:
      return {
        ...state,
        servers: state.servers.map(server =>
          server.id === action.payload.id 
            ? { ...server, ...action.payload.data }
            : server
        )
      };
    
    case types.DELETE_SERVER:
      return {
        ...state,
        servers: state.servers.filter(server => server.id !== action.payload)
      };
    
    case types.SET_SERVERS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
  
    default:
      return state;
  }
}



